import { render, staticRenderFns } from "./minigamesModal.vue?vue&type=template&id=144452a2&lang=pug&"
import script from "./minigamesModal.vue?vue&type=script&lang=js&"
export * from "./minigamesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports